import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './ImageSlider.scss';
import cx from 'classnames';
import Triangle from '../../../components/Request/Triangle';

function ImageSlider({ images, parts, setParts, scale, setScale, isReadOnly }) {
  const [refresh, setRefresh] = useState();
  const [index, setIndex] = useState(0);
  const [cursor, setCursor] = useState({ x: 0, y: 0 });
  const [firstReload, setFirstReload] = useState();

  const imgId = '__IMAGINE_PART_IMAGE__';

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
    setScale(1);
  };

  const handleClick = (e, _id) => {
    if (isReadOnly) return;
    const mainWrapperElement = document.querySelector('.active #imageMainWrapper');
    var x = e.clientX - 15 - getPosition(mainWrapperElement).left;
    var y = e.clientY - 20 - getPosition(mainWrapperElement).top;

    setParts([
      ...parts,
      {
        id: parts.length + 1,
        x: x,
        y: y,
        showInput: true,
        imageId: index,
        screenX: document.querySelector('.active img').offsetWidth,
        screenY: document.querySelector('.active img').offsetHeight,
        currentImageId: _id,
      },
    ]);
  };

  function getPosition(element) {
    var clientRect = element.getBoundingClientRect();
    return {
      left: clientRect.left + document.body.scrollLeft,
      top: clientRect.top + document.body.scrollTop,
    };
  }

  const handleMove = (e) => {
    e.preventDefault();
    const mainWrapperElement = document.querySelector('.active #imageMainWrapper');
    var x = e.clientX - 100 - getPosition(mainWrapperElement).left;
    var y = e.clientY - 100 - getPosition(mainWrapperElement).top;
    setCursor({ x: x, y: y });
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) e.target.blur();
  };

  const onBlur = (value, _id) => {
    let _parts;
    if (!value) _parts = parts.filter((item) => item.id !== _id);
    else
      _parts = parts.map((item) => {
        if (item.id === _id) {
          item.value = value;
          item.name = value.charAt(0).toUpperCase() + value.slice(1);
          item.label = value.charAt(0).toUpperCase() + value.slice(1);
          item.showInput = false;
        }
        return item;
      });
    setParts(_parts);
  };

  const handleImageDrag = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  useEffect(() => {
    setFirstReload(true);
  }, []);

  useEffect(() => {
    console.log(document.querySelector(`.active #${imgId}`)?.offsetWidth);
  }, [refresh]);

  return (
    <>
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        // onSlid={onSlid}
        interval={null}
        className={cx('requestImageSlider', isReadOnly && 'hideIndicators')}>
        {images.map((_image, _index) => (
          <Carousel.Item key={_index}>
            <div className={cx('image-wrapper', !isReadOnly ? 'w-100' : 'w-auto')}>
              <div
                id="imageMainWrapper"
                className={'image-sub-wrapper position-relative'}
                onMouseMove={handleMove}
                onClick={(e) => handleClick(e, _image.id)}
                onDrag={handleImageDrag}
                style={isReadOnly ? { pointerEvents: 'none', cursor: 'default' } : {}}
                draggable>
                <img
                  id={imgId}
                  className={cx('d-flex m-auto', !isReadOnly ? 'w-100' : 'w-auto')}
                  src={_image.thumbnail}
                  alt={`${_index} slide`}
                  style={{ transform: `scale(${scale})` }}
                  onDrag={handleImageDrag}
                  onLoad={() => {
                    if (isReadOnly) setRefresh(true);
                  }}
                  draggable
                />
                {firstReload
                  ? parts?.map((item) => {
                      return (
                        item.currentImageId === _image.id && (
                          <div
                            style={{
                              left:
                                (document.querySelector(`.active #${imgId}`).offsetWidth /
                                  item.screenX) *
                                item.x,
                              top:
                                (document.querySelector(`.active #${imgId}`).offsetHeight /
                                  item.screenY) *
                                item.y,
                            }}
                            className={cx('partOnImage', item.showInput && 'zIndex2')}
                            key={item.id}>
                            <div className="part-count">{item.id}</div>
                            {item.showInput && (
                              <>
                                <span className="input-tooltip py-3">
                                  Give a name for the part you selected. And select to plus icon to
                                  add the customisable part
                                </span>
                                <div
                                  style={{
                                    position: 'absolute',
                                    bottom: '6.1rem',
                                    left: '0.75rem',
                                    zIndex: 2,
                                  }}>
                                  <Triangle />
                                </div>
                                <div className="input-wrapper">
                                  <input
                                    type="text"
                                    placeholder="Enter name"
                                    autoFocus
                                    onKeyDown={handleKeyDown}
                                    onBlur={(e) => onBlur(e.target.value, item.id)}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        )
                      );
                    })
                  : null}

                {!isReadOnly ? (
                  <div id="tooltip" style={{ left: cursor.x, top: cursor.y }}>
                    <span>
                      Click on part for which <br /> you want separate finish.
                    </span>
                    <div style={{ position: 'absolute', bottom: '3.1rem' }}>
                      <Triangle />
                    </div>
                    <div className="part-count">{parts.length + 1}</div>
                  </div>
                ) : null}
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
}

export default ImageSlider;
